<template>
  <div class="pt-2">
    <v-card flat>
      <v-form v-model="valid">
        <v-row no-gutters align="center" justify="space-around">
          <v-col cols="12" sm="1" style="text-align: right">
            <label>选择门店:</label>
          </v-col>
          <v-col cols="12" sm="2">
            <pd-shop-multiple-list
                v-model="filter.shopIds"
                isSearch
            ></pd-shop-multiple-list>
          </v-col>
          <v-col cols="12" sm="1" style="text-align: right">
            <label>业务事项：</label>
          </v-col>
          <v-col cols="12" sm="2">
            <v-text-field
                class="form-item-value"
                v-model="filter.itemName"
                label=""
                outlined
                dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="1" style="text-align: right">
            <label>维保状态:</label>
          </v-col>
          <v-col cols="12" sm="2">
            <v-select
                v-model="filter.status"
                :items="statusList"
                item-text="name"
                item-value="id"
                clearable
                outlined
                dense
            ></v-select>
          </v-col>
        </v-row>
        <v-row no-gutters align="center" justify="space-around">
          <v-col cols="12" sm="1" style="text-align: right">
            <label>主管复检:</label>
          </v-col>
          <v-col cols="12" sm="2">
            <v-select
                v-model="filter.supervisorPrInspec"
                :items="isRecheckList"
                item-text="name"
                item-value="id"
                clearable
                outlined
                dense
            ></v-select>
          </v-col>
          <v-col cols="12" sm="1" style="text-align: right">
            <label>经理复检:</label>
          </v-col>
          <v-col cols="12" sm="2">
            <v-select
                v-model="filter.managerPrInspec"
                :items="isRecheckList"
                item-text="name"
                item-value="id"
                clearable
                outlined
                dense
            ></v-select>
          </v-col>
          <v-col cols="12" sm="1" style="text-align: right">
            <label>所属月份:</label>
          </v-col>
          <v-col cols="12" sm="2">
            <v-select
                v-model="filter.month"
                :items="monthList"
                item-text="name"
                item-value="id"
                clearable
                outlined
                dense
            ></v-select>
          </v-col>
        </v-row>
        <v-row no-gutters align="center" justify="space-around">
          <v-col cols="12" sm="1" style="text-align: right">
            <label>所属年份：</label>
          </v-col>
          <v-col cols="12" sm="2">
            <el-date-picker
                v-model="filter.year"
                type="year"
                placeholder="选择年"
                format="yyyy 年"
                value-format="yyyy">
            </el-date-picker>
          </v-col>
          <v-col cols="12" sm="1" style="text-align: right">
          </v-col>
          <v-col cols="12" sm="2">
          </v-col>
          <v-col cols="12" sm="1"></v-col>
          <v-col cols="12" sm="2">
            <v-btn color="primary" class="mr-2" depressed @click="handleSearch">查询</v-btn>
            <v-btn depressed @click="handleResetSearch">重置</v-btn>
          </v-col>
        </v-row>
      </v-form>
      <v-data-table
          :headers="headers"
          :items="desserts"
          class="elevation-1"
          :loading="loading"
          :server-items-length="totalDesserts"
          :page.sync="filter.pageNum"
          :items-per-page.sync="filter.pageSize"
          @update:page="handlePageChanged"
          @update:items-per-page="handlePageSizeChanged"
      >
        <template v-slot:item.status="{ item }">
          {{ _jungleStatus(item.status) }}
        </template>
        <template v-slot:item.type="{ item }">
          {{ _jungleType(item.type) }}
        </template>
        <template v-slot:item.supervisorPrInspec="{ item }">
          {{ _jungleReCheck(item.supervisorPrInspec) }}
        </template>
        <template v-slot:item.managerPrInspec="{ item }">
          {{ _jungleReCheck(item.managerPrInspec) }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn text color="primary" small @click="viewDetail(item)">查看
          </v-btn>
        </template>
        <template v-slot:no-data> 查询出错或没有数据</template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import {default as OrderDetailApi} from "@/api/pd/wborder/OrderDetailApi.js";
import PlanItemApi from "@/api/pd/plan/PlanItem";

export default {
  props: {
    buttonPriviledgeList: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      tab: null,
      subjectList: [],
      monthList: [
        {id: 1, name: "一月"},
        {id: 2, name: "二月"},
        {id: 3, name: "三月"},
        {id: 4, name: "四月"},
        {id: 5, name: "五月"},
        {id: 6, name: "六月"},
        {id: 7, name: "七月"},
        {id: 8, name: "八月"},
        {id: 9, name: "九月"},
        {id: 10, name: "十月"},
        {id: 11, name: "十一月"},
        {id: 12, name: "十二月"}
      ],
      statusList: [
        {id: 1, name: "待指派"},
        {id: 3, name: "待接单"},
        {id: 5, name: "待执行"},
        {id: 7, name: "主管审批中"},
        {id: 15, name: "经理审批中"},
        {id: 12, name: "已完成"},
      ],
      typeList: [
        {id: 1, name: "自维"},
        {id: 2, name: "外委"},
      ],
      isRecheckList: [
        {id: 1, name: "是"},
        {id: 2, name: "否"},
      ],
      filter: {
        id: undefined,
        itemCode: undefined,
        shopId: undefined,
        subjectId: undefined,
        itemName: undefined,
        type: undefined,
        month: undefined,
        year: undefined,
        status: undefined,
        supervisorPrInspec: undefined,
        managerPrInspec: undefined,
        pageNum: 1,
        pageSize: 15,
      },
      headers: [
        {
          text: "记录编号",
          value: "id",
          sortable: false,
          width: 80,
          divider: true,
          groupable: false
        },
        {
          text: "事项编号",
          value: "itemCode",
          sortable: false,
          width: 80,
          divider: true,
          groupable: false
        },
        {
          text: "门店名称",
          align: "start",
          sortable: false,
          value: "shopName",
          width: 120,
          divider: true,
          groupable: false
        },
        {
          text: "所属科目",
          align: "start",
          sortable: false,
          value: "subjectName",
          width: 90,
          divider: true,
          groupable: false
        },
        {
          text: "业务事项",
          align: "start",
          sortable: false,
          value: "itemName",
          width: 120,
          divider: true,
          groupable: false
        },
        {
          text: "自维/外委",
          align: "start",
          sortable: false,
          value: "type",
          width: 60,
          divider: true,
          groupable: false
        },
        {
          text: "维保内容",
          align: "start",
          sortable: false,
          value: "wbContent",
          width: 180,
          divider: true,
          groupable: false
        },
        {
          text: "状态",
          align: "start",
          sortable: false,
          value: "status",
          width: 80,
          divider: true,
          groupable: false
        },
        {
          text: "所属年份",
          align: "start",
          sortable: false,
          value: "year",
          width: 60,
          divider: true,
          groupable: false
        },
        {
          text: "所属月份",
          align: "start",
          sortable: false,
          value: "month",
          width: 60,
          divider: true,
          groupable: false
        },
        {
          text: "主管复检",
          align: "start",
          sortable: false,
          value: "supervisorPrInspec",
          width: 90,
          divider: true,
          groupable: false
        },
        {
          text: "经理复检",
          align: "start",
          sortable: false,
          value: "managerPrInspec",
          width: 90,
          divider: true,
          groupable: false
        },
        {
          text: "修改人",
          align: "start",
          sortable: false,
          value: "updateBy",
          width: 80,
          divider: true,
          groupable: false
        },
        {
          text: "最后修改时间",
          align: "start",
          sortable: false,
          value: "updateTime",
          width: 150,
          divider: true,
          groupable: false
        },
        {
          text: "操作",
          align: "start",
          sortable: false,
          value: "actions",
          width: 80,
          divider: true,
          groupable: false
        },
      ],
      desserts: [],
      loading: false,
      totalDesserts: 0,
      valid: false,
      checkId: null,
      btnDisabled: false
    };
  },
  mounted() {
    this.getDataFromApi();
    this.getSubjectList();
  },
  methods: {
    viewDetail(item) {
      this.$emit("viewDetailCallback", {formStatus: 'detail', checkId: item.id})
    },
    handleSearch() {
      this.getDataFromApi();
    },
    handleResetSearch() {
      this.filter = {
        id: undefined,
        itemCode: undefined,
        shopId: undefined,
        subjectCode: undefined,
        itemName: undefined,
        type: undefined,
        month: undefined,
        year: undefined,
        pageNum: 1,
        pageSize: 15,
      };
      this.getDataFromApi();
    },
    handlePageChanged(pageNum) {
      this.filter.pageNum = pageNum;
      this.getDataFromApi();
    },
    handlePageSizeChanged(pageSize) {
      if (pageSize == -1) {
        pageSize = 100;
      }
      this.filter.pageNum = 1;
      this.filter.pageSize = pageSize;
      this.getDataFromApi();
    },
    getQueryParams(query) {
      return query;
    },
    getDataFromApi() {
      this.loading = true;
      this.desserts = [];
      let me = this;
      OrderDetailApi.listWbOrder(this.getQueryParams(this.filter)).then(resp => {
        OrderDetailApi.handleResponse(resp, me, function (data) {
          me.loading = false;
          me.desserts = data.rows;
          me.totalDesserts = data.total;
        }, function () {
          me.loading = false;
        })
      }).catch(error => {
        OrderDetailApi.handleNetworkError(error, me, function () {
          me.loading = false;
        })
      })
    },
    async getSubjectList() {
      let res = await PlanItemApi.listSubject();
      console.log(res)
      if (res.data.code === 200) {
        this.subjectList = res.data.data;
      } else {
        me.$dialog.error({
          text: res.data.msg,
          title: "操作失败",
        });
      }
    },
    _hasButtonPermission(name) {
      let buttonPriviledgeList = this.buttonPriviledgeList;
      let hasButton = false;
      for (let i = 0; i < buttonPriviledgeList.length; i++) {
        if (buttonPriviledgeList[i].name == name) {
          if (buttonPriviledgeList[i].hasPriviledge == "Y") {
            return true;
          } else {
            return false;
          }
        }
      }
      return false;
    },
    _jungleStatus(status) {
      if (status == 1) {
        return "待指派"
      } else if (status == 2) {
        return "已指派"
      } else if (status == 3) {
        return "待接单"
      } else if (status == 4) {
        return "已接单"
      } else if (status == 5) {
        return "待执行"
      } else if (status == 6) {
        return "已执行"
      } else if (status == 7) {
        return "审批中"
      } else if (status == 8) {
        return "已通过"
      } else if (status == 9) {
        return "不通过，退回处理"
      } else if (status == 10) {
        return "不通过，重新指派"
      } else if (status == 11) {
        return "已转单"
      } else if (status == 12) {
        return "已完成"
      } else if (status == 13) {
        return "已复检"
      } else {
        return "未完成"
      }
    },
    _jungleType(type) {
      if (type == 1) {
        return "自维"
      } else {
        return "外委"
      }
    },
    _jungleReCheck(type) {
      if (type == 1) {
        return "已复检"
      } else {
        return "未复检"
      }
    }
  },
};
</script>